module.exports = __webpack_public_path__ + "img/ia-03-1.5f3ce8e3.jpg";